import { useEffect } from "react"

export const useCostCalculations = (formData, handleInputChange) => {
  const calculateTotal = () => {
    const subtotal = Number(formData.subtotal) || 0

    const taxArray = Array.isArray(formData.tax) ? formData.tax : []
    const retentionArray = Array.isArray(formData.retention)
      ? formData.retention
      : []
    const taxSum = taxArray.reduce((acc, t) => acc + (Number(t.value) || 0), 0)
    const retentionSum = retentionArray.reduce(
      (acc, t) => acc + (Number(t.value) || 0),
      0,
    )
    const taxAmount = subtotal * (taxSum / 100)
    const retentionAmount = subtotal * (retentionSum / 100)
    const total = subtotal + taxAmount - retentionAmount
    return total.toFixed(2)
  }

  useEffect(() => {
    const newTotal = calculateTotal()
    if (newTotal === formData.total) return
    handleInputChange("total")({ target: { value: newTotal } })
  }, [formData.subtotal, formData.tax, formData.retention])

  return { calculateTotal }
}
